function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './index.css';
import React, { useEffect, useMemo, useContext, useRef, useState } from 'react';
import debounce from 'lodash/debounce';
/* import ScrollAnimation from 'react-animate-on-scroll'; */
import { Text } from "@sitecore-jss/sitecore-jss-react";
import { getColorByTheme, getDictionaryItem, getPageThemeColors, get, canUseDOM, hexToRgb } from '../../utils';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { ReactComponent as IconChevronDown } from '../../resources/icons/chevron-down.svg';
import { ReactComponent as IconChevronAltDown } from '../../resources/icons/chevron-alt-down.svg';
import { ReactComponent as IconSwap } from '../../resources/icons/swap.svg';
import { ReactComponent as IconCalendar } from '../../resources/icons/calendar-fly-dubai.svg';
import CountersGroup from './components/CountersGroup';
import Datepicker from './components/DatePicker';
import LocationSelect from './components/LocationSelect';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
export const emptyDateShowObj = {
  day: '',
  dayNumber: '',
  month: '',
  monthNumber: '',
  year: ''
};
const emptyDestination = {
  value: '',
  label: ''
};
const getClassName = economy => economy ? 'Economy' : 'Business';
const FlyDubaiWidget = _ref => {
  let {
    fields,
    params,
    rendering
  } = _ref;
  /* Context elements */
  const sitecoreContext = useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl || false);
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const lang = sitecoreContext && sitecoreContext.language || 'en';
  /* End context elements */

  /* Params elements */
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ColorHex = get(params, 'ColorHex');
  const ActiveColorHex = get(params, 'ActiveColorHex');
  /* End Params elements */

  /* Field props */
  const {
    dictionary,
    contextItem
  } = fields.data;
  const returnChangeAnalytics = get(fields, 'data.returnChangeAnalytics');
  const searchSubmitAnalytics = get(fields, 'data.searchSubmitAnalytics');
  /* End field props */

  /* Dictionary terms */
  const titleWidgetText = getDictionaryItem(dictionary, 'titleWidget') || '';
  const returnText = getDictionaryItem(dictionary, 'return') || '';
  const oneWayText = getDictionaryItem(dictionary, 'oneWay') || '';
  const fromText = getDictionaryItem(dictionary, 'from') || '';
  const toText = getDictionaryItem(dictionary, 'to') || '';
  const enterDepartureText = getDictionaryItem(dictionary, 'enterDeparture') || '';
  const pleaseEnterOrigin = getDictionaryItem(dictionary, 'pleaseEnterOrigin') || '';
  const enterDestinationText = getDictionaryItem(dictionary, 'enterDestination') || '';
  const pleaseEnterDestination = getDictionaryItem(dictionary, 'pleaseEnterDestination') || '';
  const useCurrentLocationText = getDictionaryItem(dictionary, 'useCurrentLocation') || '';
  const loadNMoreDestinationsText = getDictionaryItem(dictionary, 'loadNMoreDestinations') || '';
  const mostPopularText = getDictionaryItem(dictionary, 'mostPopular') || '';
  const enterValidDeparture = getDictionaryItem(dictionary, 'enterValidDeparture') || '';
  const enterValidDestination = getDictionaryItem(dictionary, 'enterValidDestination') || '';
  const searchHereText = getDictionaryItem(dictionary, 'searchHere') || '';
  const dateDeskPlaceholderDepartureText = getDictionaryItem(dictionary, 'dateDeskPlaceholderDeparture') || '';
  const dateDeskPlaceholderReturnText = getDictionaryItem(dictionary, 'dateDeskPlaceholderReturn') || '';
  const dateMobileStateSelectDepartureDateText = getDictionaryItem(dictionary, 'dateMobileStateSelectDepartureDate') || '';
  const dateMobileStateSelectReturnDateText = getDictionaryItem(dictionary, 'dateMobileStateSelectReturnDate') || '';
  const dateMobilePlaceholderDepartureDateText = getDictionaryItem(dictionary, 'dateMobilePlaceholderDepartureDate') || '';
  const dateMobilePlaceholderReturnDateText = getDictionaryItem(dictionary, 'dateMobilePlaceholderReturnDate') || '';
  const dateMobileStateDepartureDateSelectedText = getDictionaryItem(dictionary, 'dateMobileStateDepartureDateSelected') || '';
  const dateMobileStateDepartureReturnDateSelectedText = getDictionaryItem(dictionary, 'dateMobileStateDepartureReturnDateSelected') || '';
  const dateErrorSelectDepartureDateText = getDictionaryItem(dictionary, 'dateErrorSelectDepartureDate') || '';
  const dateErrorSelectReturnDateText = getDictionaryItem(dictionary, 'dateErrorSelectReturnDate') || '';
  const passengerText = getDictionaryItem(dictionary, 'passenger') || '';
  const classText = getDictionaryItem(dictionary, 'class') || '';
  const economyClassText = getDictionaryItem(dictionary, 'economyClass') || '';
  const businessClassText = getDictionaryItem(dictionary, 'businessClass') || '';
  const passengerDropTitleText = getDictionaryItem(dictionary, 'passengerDropTitle') || '';
  const passengerDropIntroText = getDictionaryItem(dictionary, 'passengerDropIntro') || '';
  const adultText = getDictionaryItem(dictionary, 'adult') || '';
  const adultHelpText = getDictionaryItem(dictionary, 'adultHelp') || '';
  const childText = getDictionaryItem(dictionary, 'child') || '';
  const childHelpText = getDictionaryItem(dictionary, 'childHelp') || '';
  const infantText = getDictionaryItem(dictionary, 'infant') || '';
  const infantHelpText = getDictionaryItem(dictionary, 'infantHelp') || '';
  const cabinClassText = getDictionaryItem(dictionary, 'cabinClass') || '';
  const economyText = getDictionaryItem(dictionary, 'economy') || '';
  const businessText = getDictionaryItem(dictionary, 'business') || '';
  const amountValidationTextInfants = getDictionaryItem(dictionary, 'amountValidationInfants') || '';
  const amountValidationTextTotal = getDictionaryItem(dictionary, 'amountValidationTextTotal') || '';
  const searchFlightsText = getDictionaryItem(dictionary, 'searchFlights') || '';
  const clearText = getDictionaryItem(dictionary, 'clear') || '';
  /* End Dictionary terms */

  /* States/Refs common */
  const [isVdsite, setIsVdsite] = useState(true);
  const [returnTicket, setReturnTicket] = useState(true);
  const [originalLocations, setOriginalLocations] = useState([]);
  const [populars, setPopulars] = useState({});
  const [flyDubaiLang, setFlyDubaiLang] = useState('en');
  const [swapLoading, setSwapLoading] = useState(false);
  const [shouldAutoopenTo, setShouldAutoopenTo] = useState(false);
  /* End States/Refs common */

  /* States/Refs elements FROM field */
  const [departures, setDepartures] = useState([]);
  const [fromFocusedOnce, setFromFocusedOnce] = useState(false);
  const [fromValue, setFromValue] = useState(emptyDestination);
  const [fromInputValue, setFromInputValue] = useState('');
  const [fromMenuOpened, setFromMenuOpened] = useState(false);
  const fromMenuOpenedRef = useRef(false);
  const [fromInvalidFilter, setFromInvalidFilter] = useState(false);
  /* End states/refs elements FROM field */

  /* States/Refs elements TO field */
  const [arrivals, setArrivals] = useState([]);
  const [toFocusedOnce, setToFocusedOnce] = useState(false);
  const [toValue, setToValue] = useState(emptyDestination);
  const [toInputValue, setToInputValue] = useState("");
  const [toMenuOpened, setToMenuOpened] = useState(false);
  const toMenuOpenedRef = useRef(null);
  const [toInvalidFilter, setToInvalidFilter] = useState(false);
  /* End states/refs elements TO field */

  /* States/Refs/Memos elements DATE field */
  const [dateOpened, setDateOpened] = useState(false);
  const dateOpenedRef = useRef(null);
  const [departureDate, setDepartureDate] = useState(emptyDateShowObj);
  const [returnDate, setReturnDate] = useState(emptyDateShowObj);
  const [dateResetFlag, setDateResetFlag] = useState(false);
  const [dateFromFocusedOnce, setDateFromFocusedOnce] = useState(false);
  const [dateToFocusedOnce, setDateToFocusedOnce] = useState(false);
  const [datesAvailable, setDatesAvailable] = useState([[], []]);
  const [isMobile, setIsMobile] = useState(canUseDOM ? window.matchMedia(`(max-width: 767px)`).matches : false);
  /* End states States/Refs/Memos elements DATE field */

  /* States/Refs/Memos elements PASSENGERS AMOUNT field */
  const [economyCabinClass, setEconomyCabinClass] = useState(true);
  const [adults, setAdults] = useState(1);
  const [childrens, setChildrens] = useState(0);
  const [infants, setInfants] = useState(0);
  const [amountOpened, setAmountOpened] = useState(false);
  const amountOpenedRef = useRef(null);
  const [amountOpenFlag, setAmountOpenFlag] = useState(false);
  const allPassengers = useMemo(() => {
    return adults + childrens + infants;
  }, [adults, childrens, infants]);
  /* End states/refs/memos elements PASSENGERS AMOUNT field */

  /* Dropdowns show-hide */
  let hideFromDropdown, hideToDropdown, hideDateDD, hideAmountDD;
  if (canUseDOM) {
    hideFromDropdown = e => {
      const mobileDevice = window.matchMedia(`(max-width: 767px)`).matches;
      if (mobileDevice || !fromMenuOpenedRef.current || e.target.closest('.fields-wrapper__dest-departure') || e.target.closest('.location-select__more-btn')) return;
      setFromMenuOpened(false);
    };
    hideToDropdown = e => {
      const mobileDevice = window.matchMedia(`(max-width: 767px)`).matches;
      if (mobileDevice || !toMenuOpenedRef.current || e.target.closest('.fields-wrapper__dest-return') || e.target.closest('.location-select__more-btn')) return;
      setToMenuOpened(false);
    };
    hideDateDD = e => {
      const mobileDevice = window.matchMedia(`(max-width: 767px)`).matches;
      if (mobileDevice || !dateOpenedRef.current || e.target.closest('.fields-wrapper__date') || e.target.closest('.datepicker-dropdown') || e.target.closest('.react-datepicker__day')) return;
      setDateOpened(false);
    };
    hideAmountDD = e => {
      const mobileDevice = window.matchMedia(`(max-width: 767px)`).matches;
      if (mobileDevice || !amountOpenedRef.current || e.target.closest('.fields-wrapper__amount')) return;
      setAmountOpened(false);
    };
  }
  /* End Dropdowns show-hide */

  const debouncedCheckMobile = debounce(() => {
    setIsMobile(window.matchMedia(`(max-width: 767px)`).matches);
  }, 250);
  const dateFieldProps = {
    lang: lang,
    rtl: rtl,
    dateOpened: dateOpened,
    closeDateDropdown: () => {
      setDateOpened(false);
    },
    depDate: departureDate,
    setDepDate: setDepartureDate,
    retDate: returnDate,
    setRetDate: setReturnDate,
    resetFlag: dateResetFlag,
    setResetFlag: setDateResetFlag,
    returnTicket: returnTicket,
    setReturnTicket: setReturnTicket,
    textClear: clearText,
    oneWayText: oneWayText,
    datesAvailable: datesAvailable,
    isMobile: isMobile,
    enableAmountOpenFlag: () => {
      setAmountOpenFlag(true);
    },
    mobileStateSelectDepartureDateText: dateMobileStateSelectDepartureDateText,
    mobileStateSelectReturnDateText: dateMobileStateSelectReturnDateText,
    mobilePlaceholderDepartureDateText: dateMobilePlaceholderDepartureDateText,
    mobilePlaceholderReturnDateText: dateMobilePlaceholderReturnDateText,
    mobileStateDepartureDateSelectedText: dateMobileStateDepartureDateSelectedText,
    mobileStateDepartureReturnDateSelectedText: dateMobileStateDepartureReturnDateSelectedText
  };
  const formSubmit = () => {
    setFromFocusedOnce(true);
    setToFocusedOnce(true);
    setDateFromFocusedOnce(true);
    setDateToFocusedOnce(true);
    const allowUrlOpen = !!fromValue.value && !!toValue.value && !!departureDate.dayNumber && (!returnTicket || !!(returnTicket && returnDate.dayNumber));
    const dir = returnTicket ? 'rt' : 'ow';
    let dates = `${departureDate.year}${departureDate.monthNumber}${departureDate.dayNumber}`;
    if (returnTicket) {
      dates += `_${returnDate.year}${returnDate.monthNumber}${returnDate.dayNumber}`;
    }
    const thirdLevelDomain = isMobile ? 'm' : 'flights2';
    const touristsNumber = `${adults ? `a${adults}` : ''}${childrens ? `c${childrens}` : ''}${infants ? `i${infants}` : ''}`;
    const url = new URL(`https://${thirdLevelDomain}.flydubai.com/${flyDubaiLang}/results/${dir}/${touristsNumber}/${fromValue.value}_${toValue.value}/${dates}`);
    const queryString = new URLSearchParams({
      cabinClass: getClassName(economyCabinClass),
      isOriginMetro: fromValue.metroActive,
      isDestMetro: toValue.metroActive
    });
    url.search = queryString.toString();
    const anaLiticsReturnMessage = returnTicket ? 'Return' : 'One Way';
    let anaLiticsDateMessage = `${departureDate.day} ${departureDate.month} ${departureDate.year}`;
    if (returnTicket) {
      anaLiticsDateMessage += ` : ${returnDate.day} ${returnDate.month} ${returnDate.year}`;
    }
    if (allowUrlOpen) {
      tealiumClickFunc(tealiumMergeClickData(searchSubmitAnalytics, params), [searchFlightsText, anaLiticsReturnMessage, allPassengers, fromValue.value, toValue.value, anaLiticsDateMessage]);
      window.open(url.toString());
    }
  };
  const passengersFieldProps = {
    adults: adults,
    childrens: childrens,
    infants: infants,
    setAdults: count => {
      setAdults(count);
      if (count < infants) setInfants(count);
    },
    setChildrens: setChildrens,
    setInfants: setInfants,
    title: passengerDropTitleText,
    intro: passengerDropIntroText,
    textAdults: adultText,
    descriptionAdult: adultHelpText,
    textChildren: childText,
    descriptionChildren: childHelpText,
    textInfants: infantText,
    descriptionInfants: infantHelpText,
    textCabinClass: cabinClassText,
    textEconomy: economyText,
    textBusiness: businessText,
    textAmountValidationInfants: amountValidationTextInfants,
    textAmountValidationTotal: amountValidationTextTotal,
    economyCabinClass: economyCabinClass,
    setEconomyCabinClass: setEconomyCabinClass,
    textClear: clearText,
    textSave: searchFlightsText,
    rtl: rtl,
    close: () => {
      setAmountOpened(false);
    },
    saveAction: formSubmit
  };
  const sortAndAddValues = function (airports, metros) {
    let shouldFilter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    let currentLabel = '';
    const destinations = shouldFilter ? airports.filter(airport => airport.hasDestination) : airports.concat([]);
    destinations.sort((a, b) => a.groupLabel.localeCompare(b.groupLabel) || a.city.localeCompare(b.city));
    destinations.forEach(airport => {
      if (airport.groupLabel !== currentLabel) {
        currentLabel = airport.groupLabel;
        airport.firstInGroup = true;
      }
      airport.value = airport.airportCode;
      airport.label = airport.Name;
      const metroForAirport = metros.find(metro => metro.metros.includes(airport.airportCode) && !airport.metroActive);
      if (metroForAirport) {
        const isMetroExists = destinations.find(destination => destination.metroActive && destination.airportCode === metroForAirport.org);
        if (isMetroExists) {
          airport.asAMetroChild = metroForAirport.org;
        }
      }
    });
    return destinations;
  };

  /* Generate list with metroCildren after metro airport */
  const setMetrosInList = (airports, metrosHash) => {
    Object.keys(metrosHash).forEach(key => {
      const metroIndex = airports.findIndex(airport => airport.metroActive && key === airport.airportCode);
      if (metroIndex >= 0) {
        const metroChildrenList = [];
        metrosHash[key].forEach(metroChildCode => {
          const metroChildIndex = airports.findIndex(port => port.airportCode === metroChildCode && !port.metroActive);
          if (metroChildIndex >= 0) {
            metroChildrenList.push(...airports.splice(metroChildIndex, 1));
          }
        });
        const refreshedMetroIndex = airports.findIndex(airport => airport.metroActive && key === airport.airportCode);
        airports.splice(refreshedMetroIndex + 1, 0, ...metroChildrenList);
      }
    });
    return airports;
  };
  const getDepartures = locale => {
    const reqHeaders = new Headers();
    const requestOptions = {
      method: 'GET',
      headers: reqHeaders
    };
    Promise.all([fetch(`https://www.flydubai.com/${locale}/api/content/airports`, requestOptions), fetch(`https://www.flydubai.com/${locale}/api/content/populardestination`, requestOptions)]).then(responses => Promise.all(responses.map(response => response.status === 200 ? response.json() : null))).then(data => {
      const [airports, loadedPopulars] = data;

      /*Expand populars object with populars hash*/
      loadedPopulars.popularDestinationHash = loadedPopulars.popularDestination.reduce((acc, destination) => {
        acc[destination.org] = destination.popularDest;
        return acc;
      }, {});

      /*Expand populars object with metros hash*/
      loadedPopulars.metrosHash = loadedPopulars.metros.reduce((acc, metro) => {
        acc[metro.org] = metro.metros;
        return acc;
      }, {});

      /*Add current airport necessary props */
      loadedPopulars.currentAirport.value = loadedPopulars.currentAirport.airportCode;
      loadedPopulars.currentAirport.label = loadedPopulars.currentAirport.Name;
      setOriginalLocations(airports);
      setPopulars(loadedPopulars);

      // Set default current airport
      setFromValue(loadedPopulars.currentAirport);

      /* Create local var to manipulate array sort airports */
      const workingList = sortAndAddValues(airports, loadedPopulars.metros);

      /* Set the airports list to component state */
      setDepartures(setMetrosInList(workingList, loadedPopulars.metrosHash));
    }).catch(error => {
      console.log('catch', error);
    });
  };
  const getArrivals = () => {
    const reqHeaders = new Headers();
    const requestOptions = {
      method: 'GET',
      headers: reqHeaders
    };
    const url = new URL(`https://www.flydubai.com/${flyDubaiLang}/api/content/airports`);
    const queryString = new URLSearchParams({
      origin: fromValue.value
    });
    url.search = queryString.toString();
    fetch(url.toString(), requestOptions).then(response => response.status === 200 ? response.json() : null).then(data => {
      /* Create local var to manipulate array sort airports */
      const workingList = sortAndAddValues(data, populars.metros, false);

      /* Create most popular destination group */
      const popularDestKeys = populars.popularDestinationHash[fromValue.value] || populars.popularDestinationHash.FALLBACK;
      const popularsList = workingList.filter(airport => popularDestKeys.some(destination => airport.airportCode === destination));

      /* create list from new populars to apply them necessary props separately */
      if (popularsList.length) {
        popularsList.forEach((item, index) => {
          const newProps = {
            popularItem: true
          };
          if (index === 0) newProps.isPopularHeader = true;
          popularsList[index] = _objectSpread(_objectSpread({}, newProps), item);
          if (item.asAMetroChild) delete popularsList[index].asAMetroChild;
        });
      }

      /* Set the airports list to component state */
      setArrivals([...popularsList, ...setMetrosInList(workingList, populars.metrosHash)]);
      if (toValue.value) {
        setToValue(workingList.find(airport => toValue.value === airport.airportCode && toValue.label === airport.Name));
      } else if (shouldAutoopenTo) {
        setToMenuOpened(true);
        if (!toFocusedOnce) setToFocusedOnce(true);
      } else {
        setShouldAutoopenTo(true);
      }
    }).catch(error => {
      console.log('catch', error);
    });
  };
  const getDates = () => {
    const reqHeaders = new Headers();
    const requestOptions = {
      method: 'GET',
      headers: reqHeaders
    };
    const url = new URL(`https://www.flydubai.com/api/Calendar/${fromValue.value}/${toValue.value}`);
    const queryString = new URLSearchParams({
      fromDate: new Date().toLocaleDateString('en-GB', {
        year: 'numeric',
        month: 'short',
        day: '2-digit'
      }).replaceAll(' ', '-'),
      isOriginMetro: fromValue.metroActive,
      isDestMetro: toValue.metroActive
    });
    url.search = queryString.toString();
    fetch(url.toString(), requestOptions).then(response => response.status === 200 ? response.json() : null).then(data => {
      setDateOpened(true);
      if (swapLoading) setSwapLoading(false);
      setDatesAvailable([data.routes[0].flightSchedules, data.routes[1].flightSchedules]);
    }).catch(error => {
      console.log('catch', error);
    });
  };
  const returnValueChangeHandler = returnValue => () => {
    setReturnTicket(returnValue);
    const anaLiticsMessage = returnValue ? 'Return' : 'One Way';
    tealiumClickFunc(tealiumMergeClickData(returnChangeAnalytics, params), [anaLiticsMessage]);
  };
  useEffect(() => {
    if (canUseDOM) {
      document.addEventListener("click", hideFromDropdown);
      document.addEventListener("click", hideToDropdown);
      document.addEventListener("click", hideDateDD);
      document.addEventListener("click", hideAmountDD);
      window.addEventListener('resize', debouncedCheckMobile);
      if (!document.body.classList.contains('vdsite')) {
        setIsVdsite(false);
      }
      return () => {
        document.removeEventListener("click", hideFromDropdown);
        document.removeEventListener("click", hideToDropdown);
        document.removeEventListener("click", hideDateDD);
        document.removeEventListener("click", hideAmountDD);
        window.removeEventListener('resize', debouncedCheckMobile);
      };
    }
  }, []);
  useEffect(() => {
    const widgetLang = ['ar', 'ru', 'en'].includes(lang) ? lang : 'en';
    setFlyDubaiLang(widgetLang);
    getDepartures(widgetLang);
  }, [lang]);
  useEffect(() => {
    setDateResetFlag(true);
    if (fromValue.value) {
      getArrivals();
    }
  }, [fromValue]);
  useEffect(() => {
    setDateResetFlag(true);
    if (toValue.value) {
      getDates();
    } else {
      setDatesAvailable([[], []]);
    }
  }, [toValue.value]);
  useEffect(() => {
    if (departureDate.day) {
      setDateToFocusedOnce(true);
    }
  }, [departureDate]);
  useEffect(() => {
    fromMenuOpenedRef.current = fromMenuOpened;
    if (!fromMenuOpened) {
      setFromInputValue('');
      setFromInvalidFilter(false);
    } else {
      setFromValue(emptyDestination);
      setToValue(emptyDestination);
      setArrivals([]);
      setToFocusedOnce(false);
      setDateToFocusedOnce(false);
      setDateFromFocusedOnce(false);
    }
  }, [fromMenuOpened]);
  useEffect(() => {
    toMenuOpenedRef.current = toMenuOpened;
    if (!toMenuOpened) {
      setToInputValue('');
      setToInvalidFilter(false);
    } else {
      setToValue(emptyDestination);
      setDateToFocusedOnce(false);
      setDateFromFocusedOnce(false);
    }
  }, [toMenuOpened]);
  useEffect(() => {
    dateOpenedRef.current = dateOpened;
    if (dateOpened) {
      setDateFromFocusedOnce(true);
      setDateToFocusedOnce(true);
    }
  }, [dateOpened]);
  useEffect(() => {
    amountOpenedRef.current = amountOpened;
  }, [amountOpened]);

  /* Used a separate useeffect to run after click on body handler run - that closed the field after opening */
  useEffect(() => {
    if (amountOpenFlag) {
      setAmountOpened(true);
      setAmountOpenFlag(false);
    }
  }, [amountOpenFlag]);
  const variables = BackgroundColorHex ? {
    "--fly-dubai-widget-background-color": BackgroundColorHex,
    "--fly-dubai-widget-background-color-rgb": hexToRgb(BackgroundColorHex, true),
    "--fly-dubai-widget-background-active-color": ActiveColorHex,
    "--fly-dubai-widget-color": ColorHex
  } : {
    "--fly-dubai-widget-background-color": primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary,
    "--fly-dubai-widget-background-color-rgb": hexToRgb(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary, true),
    "--fly-dubai-widget-background-active-color": primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    "--fly-dubai-widget-color": getColorByTheme(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary)
  };
  const fromError = !fromMenuOpened && fromFocusedOnce && !fromValue.value || fromInvalidFilter;
  const toError = !toMenuOpened && toFocusedOnce && !toValue.value || toInvalidFilter;
  const dateDepartureError = !departureDate.day && dateFromFocusedOnce && !dateOpened && !swapLoading;
  const dateReturnError = !returnDate.day && dateToFocusedOnce && !dateOpened && !swapLoading;
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group",
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: "fly-dubai-widget"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-md-10"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    className: "h4 fly-dubai-widget__heading",
    field: {
      value: titleWidgetText
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "form-group wiz__form-group"
  }, /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement("legend", {
    className: "accessibility-hidden-text"
  }, titleWidgetText), /*#__PURE__*/React.createElement("span", {
    className: "form-label__container"
  }, /*#__PURE__*/React.createElement("input", {
    className: "fp__radio",
    type: "radio",
    onChange: returnValueChangeHandler(true),
    name: "return",
    id: "return-item",
    checked: returnTicket
  }), returnText && /*#__PURE__*/React.createElement("label", {
    htmlFor: "return-item",
    className: "form-label__radio"
  }, returnText)), /*#__PURE__*/React.createElement("span", {
    className: "form-label__container"
  }, /*#__PURE__*/React.createElement("input", {
    className: "fp__radio",
    type: "radio",
    onChange: returnValueChangeHandler(false),
    name: "return",
    id: "one-way-item",
    checked: !returnTicket
  }), oneWayText && /*#__PURE__*/React.createElement("label", {
    htmlFor: "one-way-item",
    className: "form-label__radio"
  }, oneWayText)))), /*#__PURE__*/React.createElement("div", {
    className: "form-wrapper row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fields-wrapper col-md d-md-flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: `fields-wrapper__dest ${fromError || toError ? 'fields-wrapper__dest--has-error' : ''}`
  }, /*#__PURE__*/React.createElement("div", {
    className: `fields-wrapper__dest-departure ${fromError ? 'fields-wrapper__dest-departure--has-error' : ''}`
  }, /*#__PURE__*/React.createElement(LocationSelect, {
    rtl: rtl,
    isMobile: isMobile,
    isOpened: fromMenuOpened,
    setIsOpened: setFromMenuOpened,
    departureField: true,
    fromValue: fromValue.value,
    toValue: toValue.value,
    fieldValue: fromValue,
    locationsList: departures,
    inputValue: fromInputValue,
    setInputValue: setFromInputValue,
    setMyLocation: () => {
      setFromValue(populars.currentAirport);
      setFromMenuOpened(false);
    },
    setValue: setFromValue,
    focusedOnce: fromFocusedOnce,
    setFocusedOnce: () => {
      setFromFocusedOnce(true);
    },
    fromText: fromText,
    toText: toText,
    labelText: fromText,
    labelHelpText: enterDepartureText,
    headerText: enterDepartureText,
    useCurrentLocationText: useCurrentLocationText,
    loadNMoreDestinationsText: loadNMoreDestinationsText,
    mostPopularText: mostPopularText,
    mobilePlaceholder: searchHereText,
    error: fromError,
    errorEmptyText: pleaseEnterOrigin,
    errorInvalidText: enterValidDeparture,
    invalidFilter: fromInvalidFilter,
    setInvalidFilter: setFromInvalidFilter
  })), /*#__PURE__*/React.createElement("div", {
    className: `fields-wrapper__dest-return ${toError ? 'fields-wrapper__dest-return--has-error' : ''}`
  }, /*#__PURE__*/React.createElement(LocationSelect, {
    rtl: rtl,
    isMobile: isMobile,
    isOpened: toMenuOpened,
    setIsOpened: setToMenuOpened,
    departureField: false,
    fromValue: fromValue.value,
    toValue: toValue.value,
    fieldValue: toValue,
    locationsList: arrivals,
    inputValue: toInputValue,
    setInputValue: setToInputValue,
    clearField: () => {
      setToMenuOpened(false);
      setFromMenuOpened(true);
    },
    setValue: setToValue,
    focusedOnce: toFocusedOnce,
    setFocusedOnce: () => {
      setToFocusedOnce(true);
    },
    textClear: clearText,
    fromText: fromText,
    toText: toText,
    labelText: toText,
    labelHelpText: enterDestinationText,
    headerText: enterDestinationText,
    loadNMoreDestinationsText: loadNMoreDestinationsText,
    mostPopularText: mostPopularText,
    mobilePlaceholder: searchHereText,
    error: toError,
    errorEmptyText: pleaseEnterDestination,
    errorInvalidText: enterValidDestination,
    invalidFilter: toInvalidFilter,
    setInvalidFilter: setToInvalidFilter
  })), toValue.hasReturn || swapLoading ? /*#__PURE__*/React.createElement("button", {
    className: "fields-wrapper__dest-swapper",
    onClick: () => {
      setFromValue(departures.find(airport => toValue.value === airport.airportCode && toValue.label === airport.Name));
      setDateOpened(false);
      setSwapLoading(true);
      setToValue(fromValue);
    }
  }, /*#__PURE__*/React.createElement(IconSwap, {
    className: "icon"
  })) : null), /*#__PURE__*/React.createElement("div", {
    tabIndex: 0,
    className: `
                      fields-wrapper__date
                      ${returnTicket ? '' : 'fields-wrapper__date--single'}
                      ${dateDepartureError || dateReturnError ? 'fields-wrapper__date--has-error' : ''}
                    `,
    onClick: () => {
      setToFocusedOnce(true);
      if (toValue.value) {
        setDateOpened(true);
        if (!dateFromFocusedOnce) setDateFromFocusedOnce(true);
        if (!dateToFocusedOnce) setDateToFocusedOnce(true);
      }
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: `fields-wrapper__date-departure ${dateDepartureError ? 'fields-wrapper__date-departure--has-error' : ''}`
  }, /*#__PURE__*/React.createElement("div", {
    className: `
                        date-selector
                        ${dateOpened && !departureDate.day || departureDate.day || dateFromFocusedOnce ? '' : 'date-selector--placeholder'}
                      `
  }, /*#__PURE__*/React.createElement("span", {
    className: "date-selector__label is-ellipsed"
  }, dateDeskPlaceholderDepartureText)), /*#__PURE__*/React.createElement("div", {
    className: "date-selector-value"
  }, /*#__PURE__*/React.createElement("div", {
    className: "date-selector-value__day"
  }, departureDate.day), /*#__PURE__*/React.createElement("div", {
    className: "date-selector-value__month"
  }, departureDate.month)), /*#__PURE__*/React.createElement(IconCalendar, {
    className: "icon"
  }), dateOpened && /*#__PURE__*/React.createElement("div", {
    className: "fields-wrapper__date-arrow"
  }), dateDepartureError && /*#__PURE__*/React.createElement("div", {
    className: "fields-wrapper__date-departure-error is-ellipsed"
  }, dateErrorSelectDepartureDateText)), returnTicket && /*#__PURE__*/React.createElement("div", {
    className: `fields-wrapper__date-return ${dateReturnError ? 'fields-wrapper__date-return--has-error' : ''}`
  }, /*#__PURE__*/React.createElement("div", {
    className: `
                          date-selector
                          ${dateOpened && departureDate.day && !returnDate.day || returnDate.day || dateToFocusedOnce ? '' : 'date-selector--placeholder'}
                        `
  }, /*#__PURE__*/React.createElement("span", {
    className: "date-selector__label is-ellipsed"
  }, dateDeskPlaceholderReturnText)), /*#__PURE__*/React.createElement("div", {
    className: "date-selector-value"
  }, /*#__PURE__*/React.createElement("div", {
    className: "date-selector-value__day"
  }, returnDate.day), /*#__PURE__*/React.createElement("div", {
    className: "date-selector-value__month"
  }, returnDate.month)), /*#__PURE__*/React.createElement(IconCalendar, {
    className: "icon"
  }), dateReturnError && /*#__PURE__*/React.createElement("div", {
    className: "fields-wrapper__date-return-error is-ellipsed"
  }, dateErrorSelectReturnDateText))), /*#__PURE__*/React.createElement("div", {
    className: "fields-wrapper__amount"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fields-wrapper__amount-passenger d-md-none",
    tabIndex: 0,
    onClick: () => {
      setAmountOpened(true);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "amount-label"
  }, passengerText), /*#__PURE__*/React.createElement("div", {
    className: "amount-drop"
  }, /*#__PURE__*/React.createElement("span", {
    className: "amount-main-text"
  }, allPassengers, ' ', passengerText), /*#__PURE__*/React.createElement(IconChevronDown, {
    className: "icon"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "fields-wrapper__amount-class d-md-none",
    tabIndex: 0,
    onClick: () => {
      setAmountOpened(true);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "amount-label"
  }, classText), /*#__PURE__*/React.createElement("div", {
    className: "amount-drop"
  }, /*#__PURE__*/React.createElement("span", {
    className: "amount-main-text"
  }, economyCabinClass ? economyText : businessText), /*#__PURE__*/React.createElement(IconChevronDown, {
    className: "icon"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "d-none d-md-flex fields-wrapper__amount-desk-inner",
    tabIndex: 0,
    onClick: () => {
      setAmountOpened(true);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "fields-wrapper__amount-desk-texts"
  }, /*#__PURE__*/React.createElement("div", {
    className: "amount-label is-ellipsed"
  }, passengerText), /*#__PURE__*/React.createElement("div", {
    className: "fields-wrapper__amount-desk-passengers amount-main-text is-ellipsed"
  }, allPassengers, ' ', passengerText), /*#__PURE__*/React.createElement("div", {
    className: "amount-label is-ellipsed"
  }, economyCabinClass ? economyClassText : businessClassText)), /*#__PURE__*/React.createElement(IconChevronAltDown, {
    className: "icon fields-wrapper__amount-desk-arrow"
  })), amountOpened && /*#__PURE__*/React.createElement(CountersGroup, passengersFieldProps)), /*#__PURE__*/React.createElement(Datepicker, dateFieldProps)), /*#__PURE__*/React.createElement("div", {
    className: "btn-wrapper col-md-auto"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary",
    onClick: formSubmit
  }, searchFlightsText))))))));
};
const commonStyles = "c1nuxsww";
const ltrStyles = "l10q4gf3";
const rtlStyles = "r1sx1zc1";
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    anchorUrlParameter
  } = _ref2;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    fullWidth: true,
    minHeight: true,
    className: ` ${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
export default FlyDubaiWidget;